import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import utils from "@rentiohq/web-shared/dist/utils";
import * as t from "../../../../../services/translationService";

/**
 * A moment on the candidate list, without the year while it is this year.
 *
 * The list is a dense screen and the year is the same on nearly every row, so
 * it costs six characters per date and tells the broker nothing. Dropping it
 * outright would be worse though: a visit from a previous year would read as if
 * it happened this one, and on the archive tab that is not hypothetical.
 *
 * So it is left out only when it is the current year, which keeps the common
 * case short and the rare case honest without anybody having to think about it.
 */
export const formatListMoment = (
  value: Date | string,
  now: Date = new Date(),
) => {
  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) {
    return "";
  }

  const pattern =
    date.getFullYear() === now.getFullYear()
      ? "dd/MM HH:mm"
      : "dd/MM/yyyy HH:mm";

  return utils.date.format(date, pattern);
};

/** The same rule for a date shown without a time, such as a move-in date. */
export const formatListDate = (
  value: Date | string,
  now: Date = new Date(),
) => {
  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) {
    return "";
  }

  return utils.date.format(
    date,
    date.getFullYear() === now.getFullYear() ? "dd/MM" : "dd/MM/yyyy",
  );
};

export const getSetInfo = (application: IApplication) => {
  // TODO: @dries move interface extension to shared
  const { step, stepStartedAt, stepCompletedAt } =
    application as IApplication & {
      step: number;
      stepStartedAt: string;
      stepCompletedAt?: string;
    };

  if (stepCompletedAt) {
    return `${t.applicationStepCompletedAtRentmatch(step)} ${formatListMoment(
      stepCompletedAt,
    )}`;
  }

  return `${t.applicationStepProvidedAtRentmatch(step)} ${formatListMoment(
    stepStartedAt,
  )}`;
};
